import React from "react";
import CustomerDetails from "./components/index"

function App() {
  return (
    <div>
      <CustomerDetails />
    </div>
  );
}

export default App;
